import { render, staticRenderFns } from "./TGrid.vue?vue&type=template&id=610ee4a8&"
import script from "./TGrid.vue?vue&type=script&lang=js&"
export * from "./TGrid.vue?vue&type=script&lang=js&"
import style0 from "./TGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports